<template>
  <div class="kwt-checkbox">
    <div class="outer-circle">
      <div
        class="inner-circle"
        :class="getValidationClass(isChecked, hasError)"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isChecked', 'hasError'],
  methods: {
    getValidationClass(isChecked, hasError) {
      const className = [];

      if (isChecked) {
        className.push('is-checked');
      }

      if (hasError) {
        className.push('has-error');
      }

      return className.join(' ');
    }
  }
};
</script>

<style lang="scss" scoped>
  .kwt-checkbox {
    position: relative;
    display: inline-block;
    cursor: pointer;
    margin-right: 10px;

    .outer-circle {
      position:absolute;
      top: 0;
      left: 0;
      border: 2px solid gray;
      border-radius: 50%;
      height: 100%;
      width: 100%;

      .inner-circle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 50%;
        width: 50%;
        border: 2px solid gray;
        border-radius: 50%;
        background-color: lighten(gray, 35%);
        transition-property: background-color;
        transition: 0.2s;

        &.is-checked {
          background-color: limegreen;

          &.has-error {
            background-color: red;
          }
        }
      }
    }
  }
</style>
